<div class="row no-gutters anchors-set" [class.sticky]="false" [class.absolute]="true">
  <div class="col">
    <div class="section-icons-container">
      @for (section of sections; track section) {
        <div class="icon {{getLabelClass(section.label)}}" (click)="changeUrl(section.anchor); scrollTo(section.anchor);" *checkPermission="section.permission">
          <span attr.data-hover="{{section.label | translate}}"><img [src]="section.icon" alt="{{section.label | translate}}"></span>
        </div>
      }
    </div>
  </div>
</div>